/**
 * Site-wide GTM tracking listeners (#35784, #35786, #35787).
 * Loaded deferred after pg-data-layer.js when PG data layer is enabled.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function pushEcommerce(payload) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  function parsePrice(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  /**
   * GTM auto-event variables read the clicked node, not ancestors.
   * Copy click tracking attrs onto inner text/media nodes (span, img, svg, …).
   */
  function stampClickableChildren(el) {
    if (!el || el.nodeType !== 1) {
      return;
    }

    var clickType = el.getAttribute('data-click-type');
    var label = el.getAttribute('data-track-label');
    var labelSub = el.getAttribute('data-track-label-sub');
    var section = el.getAttribute('data-track-section');

    if (!section) {
      var host = el.closest('[data-track-section]');
      if (host) {
        section = host.getAttribute('data-track-section');
        el.setAttribute('data-track-section', section);
      }
    }

    if (!clickType && !label && !labelSub && !section) {
      return;
    }

    var kids = el.querySelectorAll(
      'a, button, [role="button"], .ps-widget, [ps-widget-type], span, strong, em, b, u, label, img, svg, picture, source, path, i, use'
    );
    kids.forEach(function (child) {
      if (clickType && !child.getAttribute('data-click-type')) {
        child.setAttribute('data-click-type', clickType);
      }
      if (label && !child.getAttribute('data-track-label')) {
        child.setAttribute('data-track-label', label);
      }
      if (labelSub && !child.getAttribute('data-track-label-sub')) {
        child.setAttribute('data-track-label-sub', labelSub);
      }
      if (section && !child.getAttribute('data-track-section')) {
        child.setAttribute('data-track-section', section);
      }
    });
  }

  function getWhereToBuyProductLabel() {
    var opener = document.querySelector('[data-click-type="where_to_buy"][data-track-label]');
    return opener ? opener.getAttribute('data-track-label') : '';
  }

  function stampWhereToBuyPopup(root) {
    var popups = [];
    if (root && root.nodeType === 1) {
      if (root.matches && root.matches('.ps-lightbox, [class*="ps-lightbox"]')) {
        popups.push(root);
      }
      if (root.querySelectorAll) {
        root.querySelectorAll('.ps-lightbox, [class*="ps-lightbox"]').forEach(function (node) {
          popups.push(node);
        });
      }
    } else {
      document.querySelectorAll('.ps-lightbox, [class*="ps-lightbox"]').forEach(function (node) {
        popups.push(node);
      });
    }

    var productName = getWhereToBuyProductLabel();

    popups.forEach(function (popup) {
      if (!popup.getAttribute('data-track-section')) {
        popup.setAttribute('data-track-section', 'where_to_buy');
      }

      popup.querySelectorAll(
        [
          'a',
          'button',
          '[role="button"]',
          '[role="tab"]',
          'input',
          'select',
          'label',
          '.ps-online-seller',
          '.ps-online-tab',
          '.ps-local-tab',
          '.ps-online-tab-label',
          '.ps-local-tab-label',
          '[class*="ps-tab"]',
          '.ps-map-geolocation-button',
          '.ps-map-location-button',
          '.ps-lightbox-close'
        ].join(',')
      ).forEach(function (el) {
        el.setAttribute('data-click-type', 'where_to_buy');
        el.setAttribute('data-track-section', 'where_to_buy');

        var clickText = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
        if (clickText && productName) {
          el.setAttribute('data-track-label', clickText + ' // ' + productName);
        } else if (productName) {
          el.setAttribute('data-track-label', productName);
        } else if (clickText) {
          el.setAttribute('data-track-label', clickText);
        }
      });
    });
  }

  function stampAllClickables(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-click-type]').forEach(stampClickableChildren);
  }

  // --- #35784 / #35786: Coupon banner attrs (richtext strips data-* in theme JSON) ---
  function enhanceCouponLinks() {
    var links = document.querySelectorAll(
      '.announcement-bar a[href*="pgbrandsaver.com"], .announcement-bar a[href*="coupon"], [data-announcement] a[href*="coupon"], header a[href*="pgbrandsaver.com"]'
    );
    links.forEach(function (link) {
      link.setAttribute('data-coupon-link', '');
      link.setAttribute('data-coupon-intent', 'true');
      link.setAttribute('data-track-label', 'free coupon');
      link.setAttribute('data-click-type', 'nav');
      link.setAttribute('data-track-section', 'top-nav');
      stampClickableChildren(link);
    });
  }

  function enhanceNavClickables() {
    document.querySelectorAll(
      'header [data-click-type="nav"], .announcement-bar [data-click-type="nav"], .meganav [data-click-type="nav"], .mobile-menu [data-click-type="nav"]'
    ).forEach(function (el) {
      if (!el.getAttribute('data-track-section')) {
        el.setAttribute('data-track-section', 'top-nav');
      }
      stampClickableChildren(el);
    });
  }

  function initDomStamps() {
    enhanceCouponLinks();
    enhanceNavClickables();
    stampAllClickables(document);
    stampWhereToBuyPopup(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDomStamps);
  } else {
    initDomStamps();
  }

  var stampObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) {
          return;
        }
        if (node.matches && node.matches('[data-click-type]')) {
          stampClickableChildren(node);
        }
        if (node.closest) {
          var clickHost = node.closest('[data-click-type]');
          if (clickHost) {
            stampClickableChildren(clickHost);
          }
          var lightboxHost = node.closest('.ps-lightbox, [class*="ps-lightbox"]');
          if (lightboxHost) {
            stampWhereToBuyPopup(lightboxHost);
          }
        }
        if (node.querySelectorAll) {
          stampAllClickables(node);
          stampWhereToBuyPopup(node);
          if (node.closest && (node.closest('.announcement-bar') || node.querySelector('a[href*="pgbrandsaver.com"]'))) {
            enhanceCouponLinks();
          }
        }
      });
    });
  });

  stampObserver.observe(document.documentElement, { childList: true, subtree: true });

  // --- #35784: Exit to Social Site ---
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest('[data-social-link]');
    if (!link) {
      return;
    }

    window.dataLayer.push({
      event: 'social_media_link_click',
      category: 'event_social_action',
      action: 'event_socialmedia_exit',
      label: link.getAttribute('data-social-platform') || '',
      value: 0
    });
  });

  // --- #35784: Trial (Coupon) Intent ---
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest('[data-coupon-link]');
    if (!link) {
      link = evt.target.closest && evt.target.closest('a[href*="pgbrandsaver.com"], a[href*="coupon"]');
      if (!link || !link.closest('header, .announcement-bar, [data-announcement]')) {
        return;
      }
    }

    window.dataLayer.push({
      event: 'event_coupon_request',
      category: 'event_coupon_action',
      action: 'event_coupon_request',
      label: '',
      value: 0
    });
  });

  // --- #35786: Product Tile Selection (select_item) ---
  document.addEventListener('click', function (evt) {
    var item = evt.target.closest && evt.target.closest('[data-input-item][data-item-list-id]');
    if (!item) {
      return;
    }

    var clickable = evt.target.closest('a, button');
    if (!clickable || !item.contains(clickable)) {
      return;
    }

    var price = parsePrice(item.getAttribute('data-item-price'));
    var sku = item.getAttribute('data-item-sku') || '';
    var name = item.getAttribute('data-title') || '';
    var brand = item.getAttribute('data-item-brand') || '';
    var index = parseInt(item.getAttribute('data-item-index'), 10);
    if (isNaN(index)) {
      index = 0;
    }

    pushEcommerce({
      event: 'select_item',
      ecommerce: {
        currency: getCurrency(),
        item_list_id: item.getAttribute('data-item-list-id') || '',
        item_list_name: item.getAttribute('data-item-list-name') || '',
        items: [
          {
            item_id: sku,
            item_name: name,
            item_brand: brand,
            price: price,
            index: index,
            quantity: 1
          }
        ]
      }
    });
  });

  // --- #35786: Where to Buy interaction (opener + PriceSpider lightbox) ---
  var lastWtbPush = 0;

  function isWtbPopupNode(el) {
    if (!el || !el.closest) {
      return null;
    }

    return el.closest(
      [
        '[class*="ps-lightbox"]',
        '[id*="ps-lightbox"]',
        '[class*="ps-modal"]',
        '[id*="ps-modal"]',
        '.ps-widget-container',
        '.ps-online-store-redirect-button',
        '.ps-local-store-redirect-button',
        '.ps-local-seller-button',
        '.ps-local-aggregate-seller-button',
        '[class*="ps-online-store"]',
        '[class*="ps-local-store"]',
        '[class*="ps-map"]',
        '[data-retailer-link]'
      ].join(',')
    );
  }

  function getWhereToBuyInteractionType(el) {
    if (!el || !el.closest) {
      return 'button_click';
    }

    if (el.closest('select, option, [class*="ps-product-select"], [class*="ps-variant"], [class*="ps-sku-select"]')) {
      return 'select_product';
    }
    if (el.closest('[class*="ps-map"], [class*="ps-local"]')) {
      return 'map_interaction';
    }
    return 'button_click';
  }

  function pushWhereToBuyInteraction(el) {
    var now = Date.now();
    if (now - lastWtbPush < 250) {
      return;
    }
    lastWtbPush = now;

    window.dataLayer.push({
      event: 'where_to_buy_interaction',
      interaction_type: getWhereToBuyInteractionType(el),
      interaction_description: 'clicked'
    });
  }

  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || !target.closest) {
        return;
      }

      var opener = target.closest('[data-click-type="where_to_buy"], [ps-widget-type="lightbox"]');
      var popup = isWtbPopupNode(target);

      if (!opener && !popup) {
        return;
      }

      pushWhereToBuyInteraction(target);
    },
    true
  );

  // --- #35787: Scalp Quiz postMessage bridge ---
  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://survey.olay.com') {
      return;
    }
    if (!e.data || e.data.__ns !== 'scalp_advisor') {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(e.data);
  });
})();
